(async () => {
  const modalHTML = `<div class="header__modal__inner js-contact-modal">
    <div class="header__modal__close js-contact-modal-close">&times;</div>
    <div class="header__modal__inner__row">
      <div class="header__modal__inner__icon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            viewBox="0 0 18 18"
            style="display: block; width: 100%; height: 100%;"
            role="none"
            >
            <g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-width="1">
                <g fill="var(--lime)" id="Icons-Communication" transform="translate(-85.000000, -126.000000)">
                    <g transform="translate(85.000000, 126.000000)">
                        <path d="M3.6,7.8 C5,10.6 7.4,12.9 10.2,14.4 L12.4,12.2 C12.7,11.9 13.1,11.8 13.4,12 C14.5,12.4 15.7,12.6 17,12.6 C17.6,12.6 18,13 18,13.6 L18,17 C18,17.6 17.6,18 17,18 C7.6,18 0,10.4 0,1 C0,0.4 0.4,0 1,0 L4.5,0 C5.1,0 5.5,0.4 5.5,1 C5.5,2.2 5.7,3.4 6.1,4.6 C6.2,4.9 6.1,5.3 5.9,5.6 L3.6,7.8 L3.6,7.8 Z" id="Shape"/>
                    </g>
                </g>
            </g>
            </svg>
      </div>
      <h2 class="header__modal__inner__title">CONTACT US</h2>
    </div>
    <div class="header__top__contact-info" style="border-left: none; border-right: none; margin-bottom: 12px;">
      <div class="header__top__expert-advice" style="justify-content: center;">
        <div class="header__top__expert-advice__image-container">
          <img class="header__top__expert-advice__image" src="/cdn/shop/t/302/assets/call-center-rep_300x300.jpeg?v=29173002167000123341750273406" alt="Call Center Representative" style="border-radius: 50%;" width="48" height="48">
          <p
            class="online-indicator online-indicator--inactive js-online-indicator"
          >
            <span class="online-indicator__dot-wrapper">
              <span class="online-indicator__dot">
                <span class="online-indicator__blink"></span>
              </span>
            </span>
            <span class="online-indicator__status">Online</span>
          </p>

        </div>
        <div class="header__top__expert-advice__text">
          <p class="header__top__expert-advice__title" style="margin-top: auto">Get Expert Advice</p>
          <p class="header__top__expert-advice__phone" style="line-height: 1">(888) 999-1522</p>
          <p style="margin: 0; margin-top: auto">M-F 8 AM - 5:30 PM CT</p>
        </div>
      </div>
  </div>
  <a href="tel:8889991522" class="header__modal__inner__btn">(888) 999-1522</a>
  </div>`;

  const triggers = Array.from(document.querySelectorAll('.js-contact-trigger'));
  for (const trigger of triggers) {
    trigger.addEventListener('click', () => {
      const modalElement = document.createElement('div');
      modalElement.classList.add('header__modal', 'header__modal--open');
      modalElement.innerHTML = modalHTML;
      document.querySelector('html').classList.add('stop-scroll');
      document.querySelector('body').append(modalElement);
      (window.toggleIndicators || (() => {}))();
      setTimeout(() => {
        document.addEventListener(
          'click',
          (e) => {
            if (!modalElement.contains(e.target)) {
              document.querySelector('html').classList.remove('stop-scroll');
              modalElement.remove();
            }
          },
          { once: true }
        );
      });
      modalElement.querySelector('.js-contact-modal-close').addEventListener('click', (e) => {
        document.querySelector('html').classList.remove('stop-scroll');
        modalElement.remove();
      });
    });
  }
})();
